export default "__VITE_ASSET__OI4CqJ7m__"